// extracted by mini-css-extract-plugin
export default {"container":"zaa-z","oos":"Aaa-z","oosUx":"Baa-z","selected":"Caa-z","labelOos":"Daa-z"};